export default __webpack_public_path__ + "static/media/9_banner-busi-intelligence.dade286d.jpg";